import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-repository-extend-nav', {
  properties: {
    url: {
      type: String,
    },

    nodeId: {
      type: String,
    },
  },

  update() {
    this.nav = document.querySelector('tr-repository-nav');
    if (!this.nav || !this.url) return;

    Array.prototype.forEach.call(
      this.nav.querySelectorAll('.tr-tree-item-content.active'),
      element => element.classList.remove('active'),
    );

    const node = this.nav.querySelector(`#${this.nodeId}`);
    if (node && node.offsetWidth + node.offsetHeight > 0) {
      closest(node, '.tr-tree-item-content').classList.add('active');
    } else {
      $.ajax({
        url: this.url,
        type: 'get',
        dataType: 'script',
      });
    }
  },
});
